import React from "react";
import { HOW_IT_WORKS_STEPS } from "../homeV2.constants";
import useScrollProgress from "../hooks/useScrollProgress";
import Reveal from "./Reveal";

const HowItWorks = () => {
  const { trackRef, activeStep, fillPercent } = useScrollProgress(HOW_IT_WORKS_STEPS.length);

  return (
    <section className="hv2-hiw" id="how-it-works">
      <div className="home-v2__container">
        <Reveal as="span" className="home-v2__label hv2-hiw__label">
          How it works
        </Reveal>
        <Reveal as="h2" delay={0.04} className="home-v2__h2 hv2-hiw__title">
          Your journey to <span className="home-v2__highlight">better work</span>
        </Reveal>

        <div className="hv2-hiw__track" ref={trackRef}>
          <div className="hv2-hiw__line" />
          <div className="hv2-hiw__fill" style={{ width: `${fillPercent}%` }} />
          {HOW_IT_WORKS_STEPS.map((step, index) => (
            <div
              key={step.title}
              className={`hv2-hiw-step ${index <= activeStep ? "hv2-hiw-step--active" : ""}`}
            >
              <div className="hv2-hiw-step__circle">{index + 1}</div>
              <div>
                <div className="hv2-hiw-step__title">{step.title}</div>
                <p className="hv2-hiw-step__desc">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
